"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.combineAppRoutes = exports.sanitizeRouteKey = exports.defaultRouteOptions = void 0;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var defaultRouteOptions = {
  reactRoutes: {},
  marionetteRoutes: {}
};
exports.defaultRouteOptions = defaultRouteOptions;

var sanitizeRouteKey = function (route) {
  var _route$split = route.split('(/)'),
      baseRoute = _route$split[0];

  return baseRoute + "(/)(*notFound)";
};

exports.sanitizeRouteKey = sanitizeRouteKey;

var combineAppRoutes = function (routeOptions) {
  if (routeOptions === void 0) {
    routeOptions = defaultRouteOptions;
  }

  var _defaultRouteOptions$ = _extends({}, defaultRouteOptions, routeOptions),
      reactRoutes = _defaultRouteOptions$.reactRoutes,
      marionetteRoutes = _defaultRouteOptions$.marionetteRoutes;

  var enhancedReactRoutes = Object.keys(reactRoutes).reduce(function (routes, key) {
    var _extends2;

    return _extends({}, routes, (_extends2 = {}, _extends2[sanitizeRouteKey(key)] = reactRoutes[key], _extends2));
  }, {});
  return _extends({}, enhancedReactRoutes, marionetteRoutes);
};

exports.combineAppRoutes = combineAppRoutes;
var _default = combineAppRoutes;
exports.default = _default;